import {fulfilledState, pendingState, rejectedState, resError} from "@helpers";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import UsersService from "@services/UsersService";

export const getEditUser = createAsyncThunk(
  "user/edit",
  async ({id}, {rejectWithValue}) => {
    try {
      const response = await UsersService.viewUser({id});

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const updateUser = createAsyncThunk(
  "user/update",
  async ({id, user}, {rejectWithValue}) => {
    try {
      const response = await UsersService.updateUser({id, user});

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

const initialState = {
  target: null,
  initialTarget: null,
  isChanged: false,
  errors: null,
  error: "",
  status: "",
};

const editUserSlice = createSlice({
  name: "edit-user",
  initialState,
  reducers: {
    setTarget(state, action) {
      state.target = action.payload;
    },
    setIsChanged(state, action) {
      state.isChanged = action.payload;
    },
    setErrors(state, action) {
      state.errors = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setStatus(state, action) {
      state.status = action.payload;
    },
    clearEdit() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEditUser.pending, (state) => {
        pendingState(state);
      })
      .addCase(getEditUser.fulfilled, (state, action) => {
        if (!state.target) {
          state.target = action.payload;
        }

        state.initialTarget = action.payload;
        fulfilledState(state);
      })
      .addCase(getEditUser.rejected, (state, action) => {
        rejectedState(state, action);
      })

      .addCase(updateUser.pending, (state) => {
        pendingState(state);
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.target = action.payload;
        state.initialTarget = action.payload;
        fulfilledState(state);
      })
      .addCase(updateUser.rejected, (state, action) => {
        rejectedState(state, action);
      });
  },
});

export const {setIsChanged, setTarget, setError, setStatus, clearEdit} =
  editUserSlice.actions;
export default editUserSlice.reducer;
